export default {
  BOX: {
    text: 'Caixa',
    value: 'BOX',
  },
  BAG: {
    text: 'Saco',
    value: 'BAG',
  },
  TUBE: {
    text: 'Tubo',
    value: 'TUBE',
  },
  ENVELOPE: {
    text: 'Envelope',
    value: 'ENVELOPE',
  },
  PALLET: {
    text: 'Palete',
    value: 'PALLET',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/enums/EnumVolumeType.js